<template>
  <div class="field-detail">
    <nav-header :activeIndex="1" />
    <header class="field-detail-header">
      <div class="field-detail-header-banner">
        <div class="dialog"></div>
        <img :src="fieldDetail && fieldDetail.backgroundImg" alt="">
        <div class="field-detail-header-banner-inner">
          <div class="field-detail-header-banner-inner-title">首页 > 圣诉服务 > <span>{{fieldDetail && fieldDetail.fieldName}}服务</span></div>
          <div class="field-detail-header-banner-inner-tit">{{fieldDetail && fieldDetail.fieldName}}服务</div>
          <div class="field-detail-header-banner-inner-txt">
            {{fieldDetail && fieldDetail.fieidDetails}}
          </div>
        </div>
      </div>
    </header>
    <main class="field-detail-content">
      <section class="field-detail-content-sec" v-if="servicePlan[0].title || servicePlan[1].title || servicePlan[2].title">
        <div class="field-detail-content-sec-title">
          <p>量身定制服务方案</p>
        </div>
        <div class="field-detail-content-sec-content-service">
          <div class="field-detail-content-sec-content-service-item" v-for="(item, index) in servicePlan"
               v-if="item.title"
               :key="index">
            <div class="field-detail-content-sec-content-service-item-title">0{{index+1}}<span>{{item.title}}</span></div>
            <div class="field-detail-content-sec-content-service-item-con">
              <p>{{item.content}}</p>
            </div>
            <div class="field-detail-content-sec-content-service-item-detail" @click="getMeiqia">了解详情</div>
          </div>
        </div>
      </section>
      <lawyer-list :lawyerList="lawyerList" @getCity="getCity" />
      <section class="field-detail-content-sec">
        <article-list :articleList="articleList" />
      </section>
    </main>
  </div>
</template>

<script>
  import Icon from '@/common-components/icon'
  import LawyerList from '@/common-components/lawyer-list'
  import ArticleList from '@/common-components/article-list'
  import NavHeader from '@/common-components/nav-header'
  import api from './api'
  import { Message } from 'element-ui/lib'
  import { clickShowMeiQia } from '@/utils/meiqia'
  export default {
    name: 'field-detail',
    components: {
      Icon, ArticleList, LawyerList, NavHeader
    },
    data () {
      return {
        lawyerList: [],
        articleList: [],
        fieldDetail: null,
        title: '',
        city: '',
        expertField: '',
        servicePlan: [{content: '', title: ''}, {content: '', title: ''}, {content: '', title: ''}]
      }
    },
    mounted () {
      this.$route.query.id && this.getFiledDetail(this.$route.query.id)
    },
    methods: {
      // 获取领域详情
      getFiledDetail (id) {
        api.getFieldDetail(id).then(res => {
          this.fieldDetail = res.data.data
          this.expertField = res.data.data.fieldName
          this.getPositionLawyer()
          this.getArticleList()
          this.servicePlan = JSON.parse(this.fieldDetail.servicePlan)
        })
      },
      // 获取律师列表
      async getPositionLawyer () {
        let obj = {
          pageIndex: 1,
          pageSize: 3,
          expertField: this.expertField
        }
        let res = await api.getPositionLawyerList(obj)
        if (res.data.isSuccess) {
          this.lawyerList = res.data.data.list
        } else {
          Message.error(res.data.resultMsg)
        }
      },
      // 获取文章列表
      getArticleList () {
        let params = {
          pageIndex: 1,
          pageSize: 5,
          title: '',
          type: this.expertField
        }
        api.getArticleList(params).then(res => {
          this.articleList = res.data.data.list
        })
      },
      // 获取地理位置
      getCity (city) {
        this.city = city
      },
      getMeiqia () {
        clickShowMeiQia()
      }
    }
  }
</script>

<style lang='stylus' scoped>
  @import '../../styles/constant.styl'
  .field-detail {
    &-header {
      &-banner {
        width: 100%
        height: 4.4rem
        margin-top .72rem
        position relative
        img {
          width: 100%
          height: 100%
        }
        .dialog {
          width: 100%
          height: 4.4rem
          background #000
          position absolute
          top 0
          left 0
          opacity .5
        }
        &-inner {
          position absolute
          top .24rem
          left 2.5rem
          color: #fff
          &-title {
            font-size: .16rem;
            color: #fff;
            margin-bottom .48rem
            span {
              color: #a9a9a9;
            }
          }
          &-tit {
            font-size: .6rem
            font-weight: 600
            margin-bottom .19rem
          }
          &-txt {
            width: 9.4rem
            font-size: .24rem;
            font-weight: 300;
            line-height: .32rem
          }
        }
      }
    }
    &-content {
      background #f7f7f7
      padding .6rem 0 1rem 0
      &-sec {
        width: 9.4rem
        margin 0 auto
        &-title {
          display: flex
          justify-content space-between
          height: .5rem
          align-items center
          margin-bottom .45rem
          p {
            height: .5rem
            border-left .04rem solid #ed6c00
            font-size: .36rem;
            padding-left .16rem
          }
        }
        &-content-service {
          width: 100%
          display flex
          justify-content space-around
          &-item {
            width: 3rem
            height: 3.4rem
            padding 0 .37rem 0 .2rem
            background #fff
            position relative
            &-title {
              font-size: .6rem;
              font-weight: 300;
              color: #3e3a3a;
              height .94rem
              display flex
              align-items center
              span {
                font-size: .24rem
                font-weight: 500;
                color: #1d1b1b;
                margin-left .25rem
              }
            }
            &-con {
              font-size: .18rem
              line-height: 1.5;
              color: #3e3a3a;
            }
            &-detail {
              font-size: .18rem
              font-weight: 500;
              color: #ed6c00;
              position absolute
              bottom .3rem
              left .2rem
              cursor pointer
            }
          }
        }
      }
      .home-wrap-content-sec {
        &-lawyer {
          width: 9.6rem
          margin 0 auto
          padding .72rem 0 .94rem 0
          &-title {
            display: flex
            justify-content space-between
            height: .5rem
            align-items center
            p {
              height: .5rem
              border-left .04rem solid #ed6c00
              font-size: .36rem;
              padding-left .16rem
            }
            .location {
              line-height .5rem
              span {
                font-size: .18rem
                color: #ed6c00;
                position relative
                bottom .05rem
                mwrgin-left .1rem
                font-weight: 500
              }
            }
          }
          &-wrap {
            margin .54rem 0 .48rem 0
            display: flex
            justify-content space-around
            &-item {
              width: 3rem
              position relative
              box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.04)
              background #fff
              img {
                width: 100%
                height: 4rem
              }
              &-content {
                position absolute
                top 0
                left 0
                width: 100%
                height: 4rem
                color #fff
                display flex
                flex-direction column
                justify-content space-between
                align-items center
                &-top {
                  color: #fdba78;
                  font-size: .16rem
                  margin-top .24rem
                }
                &-bottom {
                  position: absolute
                  bottom .16rem
                  text-align center
                  &-name {
                    font-size: .24rem;
                    font-weight: 500;
                    maargin .14rem 0 .08rem 0
                  }
                  &-lawfirm, &-position {
                    font-size: .14rem
                  }
                }
              }
              &-text {
                padding .21rem .25rem .20rem .24rem
                &-top {
                  display flex
                  justify-content space-between
                  .lawyer-title {
                    font-size: .14rem;
                    font-weight: 500;
                    line-height: 1.14;
                    color: #1d1b1b
                    margin-bottom .15rem
                  }
                  &-left {
                    &-domain {
                      p {
                        padding .07rem .16rem
                        border-radius: .3rem;
                        background-color: #ffe9d2;
                        font-size: .14rem
                        color: #ed6c00
                        margin-bottom .08rem
                      }
                    }
                  }
                  &-right-circle {
                    position relative
                    width 1rem;
                    height 1rem;
                    &-txt {
                      position absolute
                      left 0
                      top 0
                      width: 100%
                      height: 100%
                      line-height 1rem
                      text-align center
                      font-weight: 500
                      color: #ed6c00
                      font-size: .24rem
                    }
                  }
                }
                &-center {
                  font-size: .14rem
                  color: #3e3a3a;
                }
                &-bottom {
                  margin-top .24rem
                  font-size: .16rem
                  font-weight: 500
                  .icon {
                    margin-left .08rem
                    position relative
                    top .03rem
                  }
                }
              }
            }
          }
          &-btn {
            width: 4.32rem
            height: .64rem
            background-color: #ed6c00;
            font-size: .24rem
            text-align: center
            line-height .64rem
            color: #ffffff
            margin 0 auto
          }
        }
      }
      .home-service-content-sec-content-article {
        margin-top .39rem
        &-item {
          display flex
          margin-top .16rem
          img {
            width: 2.2rem
            height: 1.65rem
            flex-shrink 0
          }
          &-msg {
            width: 7.2rem
            padding .24rem
            position relative
            background #fff
            &-title {
              font-size: .18rem
              font-weight: 500
              line-height: .36rem
            }
            &-paragraph {
              font-size: .14rem
              color: #3e3a3a;
              line-height .22rem
            }
            &-detail {
              position absolute
              bottom .24rem
              right .24rem
              font-size: .18rem
              .icon {
                position relative
                top .03rem
                margin-left .1rem
              }
            }
          }
        }
        &-btn {
          width: 4.32rem
          height: .64rem
          background-color: #ed6c00;
          font-size: .24rem
          text-align: center;
          color: #ffffff
          line-height .64rem
          margin .48rem auto .72rem
        }
      }
    }
  }
  .active {
    color: #ed6c00
  }
</style>



// WEBPACK FOOTER //
// src/components/field-detail/field-detail.vue